import { render, staticRenderFns } from "./TrashedSelect.vue?vue&type=template&id=267076d1&scoped=true"
import script from "./TrashedSelect.ts?vue&type=script&lang=ts&external"
export * from "./TrashedSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./TrashedSelect.scss?vue&type=style&index=0&id=267076d1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267076d1",
  null
  
)

export default component.exports